import { EntityDefinition } from '@/types/crud';

export const emailCampaignEntity: EntityDefinition = {
  name: 'emailCampaigns',
  displayName: 'Email Campaigns',
  displayNameSingular: 'Email Campaign',
  apiEndpoint: '/generic/crm_campaigns',
  idField: 'id',
  nameField: 'name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'name',
      label: 'Campaign Name',
      type: 'text',
      required: true,
      placeholder: 'Enter campaign name',
      order: 1
    },
    {
      key: 'subject',
      label: 'Subject',
      type: 'text',
      placeholder: 'Enter email subject',
      order: 2
    },
    {
      key: 'template_id',
      label: 'Template ID',
      type: 'text',
      placeholder: 'Select email template',
      order: 3
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'draft', label: 'Draft' },
        { value: 'scheduled', label: 'Scheduled' },
        { value: 'sending', label: 'Sending' },
        { value: 'sent', label: 'Sent' },
        { value: 'paused', label: 'Paused' },
        { value: 'cancelled', label: 'Cancelled' }
      ],
      defaultValue: 'draft',
      order: 4
    },
    {
      key: 'scheduled_date',
      label: 'Scheduled Date',
      type: 'datetime',
      order: 5
    },
    {
      key: 'sent_date',
      label: 'Sent Date',
      type: 'datetime',
      order: 6
    },
    {
      key: 'total_recipients',
      label: 'Total Recipients',
      type: 'number',
      defaultValue: 0,
      order: 7
    },
    {
      key: 'opened_count',
      label: 'Opened Count',
      type: 'number',
      defaultValue: 0,
      order: 8
    },
    {
      key: 'clicked_count',
      label: 'Clicked Count',
      type: 'number',
      defaultValue: 0,
      order: 9
    },
    {
      key: 'replied_count',
      label: 'Replied Count',
      type: 'number',
      defaultValue: 0,
      order: 10
    },
    {
      key: 'email_content',
      label: 'Email Content',
      type: 'textarea',
      placeholder: 'Enter email content',
      order: 11
    },
    {
      key: 'sent_count',
      label: 'Sent Count',
      type: 'number',
      defaultValue: 0,
      order: 12
    },
    {
      key: 'delivered_count',
      label: 'Delivered Count',
      type: 'number',
      defaultValue: 0,
      order: 13
    },
    {
      key: 'bounced_count',
      label: 'Bounced Count',
      type: 'number',
      defaultValue: 0,
      order: 14
    },
    {
      key: 'unsubscribed_count',
      label: 'Unsubscribed Count',
      type: 'number',
      defaultValue: 0,
      order: 15
    },
    {
      key: 'open_rate',
      label: 'Open Rate (%)',
      type: 'number',
      defaultValue: 0,
      order: 16
    },
    {
      key: 'click_rate',
      label: 'Click Rate (%)',
      type: 'number',
      defaultValue: 0,
      order: 17
    },
    {
      key: 'bounce_rate',
      label: 'Bounce Rate (%)',
      type: 'number',
      defaultValue: 0,
      order: 18
    },
    {
      key: 'created_by',
      label: 'Created By',
      type: 'text',
      hidden: true,
      order: 19
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 20
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: 'text',
      hidden: true,
      order: 21
    }
  ],
  tableColumns: [
    {
      key: 'name',
      label: 'Campaign Name',
      sortable: true
    },
    {
      key: 'subject',
      label: 'Subject',
      sortable: true
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true
    },
    {
      key: 'scheduled_date',
      label: 'Scheduled',
      sortable: true
    },
    {
      key: 'sent_date',
      label: 'Sent',
      sortable: true
    },
    {
      key: 'total_recipients',
      label: 'Recipients',
      sortable: true
    },
    {
      key: 'open_rate',
      label: 'Open Rate (%)',
      sortable: true
    },
    {
      key: 'click_rate',
      label: 'Click Rate (%)',
      sortable: true
    }
  ],
  searchFields: ['name', 'subject', 'email_content'],
  defaultSort: { field: 'created_at', direction: 'desc' }
};
